export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70a2906241240d0d6b32dcf74980751b41b405d804&name=pushAdClickData!'